import React, { useCallback } from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';

import {
  EmailField,
  useFormContext,
} from 'lidya-common-components';
import classNames from 'classnames';

export const RetypeEmailField = function () {
  const { t } = useTranslation();
  const { values: { email, rEmail } } = useFormContext();

  const validateEmail = useCallback(
    () => email !== rEmail,
    [email, rEmail],
  );

  return (
    <EmailField
      name="rEmail"
      id="rEmail"
      label={t('web.sign.up.form.remail')}
      validate={validateEmail}
      required
      size={6}
      errorMessage={t('web.sign.up.form.remail.error')}
      className={classNames('a-signupFormField', { 'a-signupFormField__withValue': rEmail.length })}
    />
  );
};

RetypeEmailField.propTypes = {};

export default RetypeEmailField;
